/* import __COLOCATED_TEMPLATE__ from './roll-out-percentage.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { action } from '@ember/object';
import type FinVoiceNumberConfiguration from 'embercom/models/fin-voice/number-configuration';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: any;
    ruleset: $TSFixMe;
    numberConfiguration: FinVoiceNumberConfiguration;
    updatePercentageRollout: (percentageRollout: number) => Promise<void>;
  };
}

export default class RollOutPercentage extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked percentageRollout: number;

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    this.percentageRollout = this.savedValue;
  }

  get numberConfiguration() {
    return this.args.numberConfiguration;
  }

  get savingDisabled() {
    return this.isInvalid || this.args.ruleset.isSaving || this.numberConfiguration?.isSaving;
  }

  get isDisabled() {
    return !this.numberConfiguration;
  }

  get isInvalid() {
    return (
      this.percentageRollout === null ||
      this.percentageRollout === undefined ||
      this.percentageRollout < 0 ||
      this.percentageRollout > 100
    );
  }

  get errorMessage() {
    return this.isInvalid
      ? this.intl.t(
          'operator.fin.setup.tabs.setup-and-go-live.phone.roll-out-percentage.error-invalid-percentage',
        )
      : undefined;
  }

  get savedValue() {
    return this.numberConfiguration?.predicates?.percentageRollout ?? 100;
  }

  @action
  resetPredicate() {
    this.percentageRollout = this.savedValue;
  }

  @action
  setPercentageRollout(value: string) {
    this.percentageRollout = parseInt(value, 10);
  }

  @action
  async updateOfficeHours() {
    if (this.isInvalid) {
      return;
    }

    await this.args.updatePercentageRollout(this.percentageRollout);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::WhoWillTalkToFin::RollOutPercentage': typeof RollOutPercentage;
  }
}
